import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MailmergeRegularCellComponent } from './regular-cell.component';


@NgModule({
  declarations: [MailmergeRegularCellComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports:[MailmergeRegularCellComponent],
})
export class MailmergeRegularCellModule { }
